module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/crocodile-mobile-portuguese.d2b0f64c.jpg";